function r(e) {
  return function(n) {
    return n == null ? void 0 : n[e];
  };
}
export {
  r as default
};
